export const SCORE_BANNER_QUERY_ROOT = "score-banner" as const;

export const scoreBannerStudentRecordsQueryKey = (
  userId: string | number | null | undefined,
) => [SCORE_BANNER_QUERY_ROOT, "student-records", userId] as const;

export const scoreBannerCombinedOrdersQueryKey = (
  uamId: string | number | null | undefined,
) => [SCORE_BANNER_QUERY_ROOT, "combined-orders", uamId] as const;
